export const API_URL_GET_SUBSCRIPTIONS = "/shop/api/subscriptions";
